import { AppBar, Box, Toolbar } from "@mui/material";
import Connector from "./Connector";
import { useAppProvider } from "../AppContext";
import ScienceIcon from "@mui/icons-material/Science";
import { toNetworkLabel } from "../utils";

function NavBar() {
  const { network, connectorRef } = useAppProvider();

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <Box sx={{ flexGrow: 1 }}>
            <img src="/logo.jpeg" alt="Cat Logo" style={{ height: "50px" }} />
          </Box>
          <Box sx={{ display: "flex", mr: 2, alignItems: "center" }}>
            <ScienceIcon />
            <span>{toNetworkLabel(network)}</span>
          </Box>
          <Box>
            <Connector ref={connectorRef} />
          </Box>
        </Toolbar>
        {/* <Divider sx={{ color: '#999'}}/> */}
      </AppBar>
    </Box>
  );
}

export default NavBar;
